import filterBy from './filterBy';
import getContentMargins from './getContentMargins';
import getI18ns from './getI18ns';
import getObjectInfo from './getObjectInfo';
import getRouteDataByKeys from './getRouteDataByKeys';
import getTheme from './getTheme';
import hasPhantomId from './hasPhantomId';
import withEdit from './withEdit';
import lodashFilter from './lodashFilter';
import addActions from './addActions';
import getPropsFromUrl from './getPropsFromUrl';

export { getPropsFromUrl, addActions, lodashFilter, getRouteDataByKeys, getI18ns, filterBy, getContentMargins, hasPhantomId, getTheme, withEdit, getObjectInfo };



// WEBPACK FOOTER //
// ./src/components/hoc/index.js